import { Routes, Route } from 'react-router-dom';
import NewLayout from './Layouts/NewLayout';
import AllLayouts from './Layouts/AllLayouts';
import HeaderLayout from './Layouts/HeaderLayout';
import FooterLayout from './Layouts/FooterLayout';
import NotFoundLayout from './Layouts/NotFoundLayout';

export default function CanvasMain() {
    return (
        <>
            <Routes>
                <Route path='/' element={<AllLayouts />} />
                <Route path='/new' element={<NewLayout />} />
                <Route path='/header' element={<HeaderLayout />} />
                <Route path='/footer' element={<FooterLayout />} />
                <Route path='/404' element={<NotFoundLayout />} />
                <Route path='*' element={<AllLayouts />} />
            </Routes>
        </>
    )
}